module.exports = __webpack_public_path__ + "cl.0cc7706bcffb2cc01422.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cl.svg
// module chunks = styles